/*
 * Shared Klaviyo "back in stock" notify form behaviour.
 * Used by the PDP (snippets/product-form.liquid) and the Quick-Add popup
 * (assets/quick-add-popup.js). Both share the same .custom-notify-form markup
 * and styles (assets/custom.css); this file owns the reveal / submit / feedback
 * logic so it is not duplicated.
 *
 * window.initKlaviyoNotifyForm({ trigger, form, getVariantId, onReveal })
 *   trigger      - the button that reveals the inline form
 *   form         - the .custom-notify-form element
 *   getVariantId - () => numeric Shopify variant id for the subscription
 *   onReveal     - optional callback fired after the form is shown
 * Returns { reset } to restore the trigger/form to their initial state.
 */
(function () {
  var COMPANY_ID = 'Y9qi6R';
  var DEFAULT_FEEDBACK_HTML =
    'We\'ll notify <span class="custom-notify-form__feedback-email"></span> if this item is available again.';

  function subscribe(email, variantId) {
    return fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + COMPANY_ID, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            }
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: '$shopify:::$default:::' + variantId
              }
            }
          }
        }
      })
    });
  }

  function initKlaviyoNotifyForm(options) {
    options = options || {};
    var trigger = options.trigger;
    var form = options.form;
    var getVariantId = options.getVariantId;
    if (!trigger || !form || !getVariantId) return null;

    var submitBtn = form.querySelector('.custom-notify-form__submit');
    var emailInput = form.querySelector('.custom-notify-form__email');
    var feedbackBlock = form.querySelector('.custom-notify-form__feedback');
    var feedbackTitle = feedbackBlock.querySelector('.custom-notify-form__feedback-title');
    var feedbackText = feedbackBlock.querySelector('.custom-notify-form__feedback-text');
    var closeBtn = feedbackBlock.querySelector('.custom-notify-form__close');

    function reset() {
      form.classList.remove('success');
      form.classList.remove('_active');
      trigger.classList.add('_active');
      submitBtn.disabled = false;
      submitBtn.textContent = 'Notify Me!';
      feedbackTitle.textContent = 'Thank you!';
      feedbackText.innerHTML = DEFAULT_FEEDBACK_HTML;
    }

    function showError() {
      feedbackTitle.textContent = 'Something went wrong.';
      feedbackText.textContent = 'Please try again.';
      form.classList.add('success');
      submitBtn.disabled = false;
      submitBtn.textContent = 'Notify Me!';
    }

    if (!trigger.dataset.klNotifyBound) {
      trigger.dataset.klNotifyBound = 'true';

      trigger.addEventListener('click', function () {
        trigger.classList.remove('_active');
        form.classList.add('_active');
        if (typeof options.onReveal === 'function') options.onReveal();
      });

      closeBtn.addEventListener('click', reset);

      submitBtn.addEventListener('click', function () {
        var email = emailInput.value.trim();
        if (!email) {
          emailInput.focus();
          return;
        }

        var variantId = getVariantId();

        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending...';

        subscribe(email, variantId)
          .then(function (res) {
            if (res.ok || res.status === 202) {
              feedbackBlock.querySelector('.custom-notify-form__feedback-email').textContent = email;
              form.classList.add('success');
            } else {
              showError();
            }
          })
          .catch(showError);
      });
    }

    return { reset: reset };
  }

  window.initKlaviyoNotifyForm = initKlaviyoNotifyForm;
})();
